module.exports = __webpack_public_path__ + "img/public/SiteIcons/modelIcon.svg?94c29cb4";